import { 
    GET_CLIENTS_LIST_PENDING,
    GET_CLIENTS_LIST_FULFILLED,
    GET_CLIENTS_LIST_REJECTED,
    GET_CLIENT_PENDING,
    GET_CLIENT_FULFILLED,
    GET_CLIENT_REJECTED,
    CLIENT_CHANGE_PROGRAM_REJECTED,
    GET_CLIENTS_COUNT_FULFILLED,

    UPDATE_CLIENT_SAVE_PENDING,
    UPDATE_CLIENT_SAVE_AND_CLOSE_PENDING,
    TRANSFER_CLIENT_PENDING,
    ARCHIVE_CLIENT_PENDING,
    CLIENT_CHANGE_PROGRAM_PENDING,

    TRANSFER_CLIENT_FULFILLED,
    CLIENT_CHANGE_PROGRAM_FULFILLED,
    ARCHIVE_CLIENT_FULFILLED,
    UPDATE_CLIENT_SAVE_FULFILLED,
    UPDATE_CLIENT_SAVE_AND_CLOSE_FULFILLED,
} from '../../actions/action-constants';

const initialState = {
    clientEntry: [],
    clients: [],
    alchoholaftercareprograms: [],
    bop: [],
    drugaftercareprograms: [],
    financialresponsibilityprograms: [],
    gangaffiliations: [],
    institutions: [],
    bopinstitutions: [],
    levelsofsecurity: [],
    referralsources: [],
    count: -1,
    boprrccount: -1,
    opcusptspsycount: -1,
    loadingList: false,
    updateSuccessSave: false,
    updateSuccessSaveAndClose: false,
    transferSuccess: false,
    changeProgramSuccess: false,
    archiveSuccess: false,

    dataEntry: {},
    dataList: [],
    
    errorInvalidEntry: false,
    errors: [],
};

const reducerClients = (state = initialState, action) => {
  var dataEntry;
  var dataList;
  switch (action.type) {

    case UPDATE_CLIENT_SAVE_PENDING:
    case UPDATE_CLIENT_SAVE_AND_CLOSE_PENDING:
    case ARCHIVE_CLIENT_PENDING:
    case TRANSFER_CLIENT_PENDING:
    case CLIENT_CHANGE_PROGRAM_PENDING:
    case GET_CLIENT_PENDING:
    case GET_CLIENTS_LIST_PENDING:
        state = {
            ...state
            , loadingList: true
        };
        break;
    case GET_CLIENTS_COUNT_FULFILLED:
        var tblcount = -1;
        var boprrccount = -1;
        var opcusptspsycount = -1;
        dataEntry = (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) ? action.payload.data.clientscount[0] : [] ;
        if (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) {
            tblcount = dataEntry.count;
            boprrccount = dataEntry.boprrccount;
            opcusptspsycount = dataEntry.opcusptspsycount;
        }
        state = {
            ...state,
            loadingList: false,
            addSuccess: false,
            updateSuccessSave: false,
            updateSuccessSaveAndClose: false,
            deleteSuccess: false,
            changeProgramSuccess: false,
            transferSuccess: false,
            archiveSuccess: false,
            errorInvalidEntry: false,
            count: tblcount,
            boprrccount: boprrccount,
            opcusptspsycount: opcusptspsycount,
        };
        break;
    case GET_CLIENTS_LIST_FULFILLED:
        dataList = (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) ? action.payload.data.clients : [] ;
        state = {
            ...state,
            loadingList: false,
            addSuccess: false,
            updateSuccessSave: false,
            updateSuccessSaveAndClose: false,
            deleteSuccess: false,
            errorInvalidEntry: false,
            dataList: dataList,
        };
        break;
    case GET_CLIENT_FULFILLED:
        // console.log("66-77-66 data ");
        // console.log(action.payload.data);
        var invalidEntry = false;
        if(action.payload.data.clients.length > 0) {
            dataEntry = (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) ? action.payload.data.clients[0] : [] ;

            if (dataEntry.program === '' || dataEntry.program === null ) {
                dataEntry.program = '1';
            } else {
                dataEntry.program = dataEntry.program.toString();;
            }
            
            if (dataEntry.referraloutcome === '' || dataEntry.referraloutcome === null ) {
                dataEntry.referraloutcome = '1';
            } else {
                dataEntry.referraloutcome = dataEntry.referraloutcome.toString();;
            }
        
            if (dataEntry.clientdischargestatus === '' || dataEntry.clientdischargestatus === null ) {
                dataEntry.clientdischargestatus = '1';
            } else {
                dataEntry.clientdischargestatus = dataEntry.clientdischargestatus.toString();;
            }
        
            if (dataEntry.clientdischargesubstatus === '' || dataEntry.clientdischargesubstatus === null ) {
                dataEntry.clientdischargesubstatus = '1';
            } else {
                dataEntry.clientdischargesubstatus = dataEntry.clientdischargesubstatus.toString();;
            }
        } else {
            dataEntry = {};
            invalidEntry = true;
        }
        state = {
            ...state,
            loadingList: false,
            errorInvalidEntry: invalidEntry,
            dataEntry: dataEntry,
            clients: [],
        };
        break;
    case UPDATE_CLIENT_SAVE_FULFILLED:
        state = {
            ...state,
            loadingList: false,
            updateSuccessSave: true,
            updateSuccessSaveAndClose: false,
        };
        break;
    case UPDATE_CLIENT_SAVE_AND_CLOSE_FULFILLED:
        state = {
            ...state
            , loadingList: false
            , updateSuccessSave: false
            , updateSuccessSaveAndClose: true
        };
        break;
    case CLIENT_CHANGE_PROGRAM_FULFILLED:
        state = {
            ...state
            , loadingList: false
            , changeProgramSuccess: true
        };
        break;
    case TRANSFER_CLIENT_FULFILLED:
        state = {
            ...state
            , loadingList: false
            , transferSuccess: true
        };
        break;
    case ARCHIVE_CLIENT_FULFILLED:
        state = {
            ...state
            , loadingList: false
            , archiveSuccess: true
        };
        break;
    case GET_CLIENTS_LIST_REJECTED:
    case GET_CLIENT_REJECTED:
    case CLIENT_CHANGE_PROGRAM_REJECTED:
        state = {
            ...state
            , errors: [action.payload.response]
        };
        break;                
    default:
        return state;
  }

  return state;
};

export default reducerClients;